import { styled } from 'styled-components';
import { Media } from '../../theme/Media';
const SectionTitle = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 22px;
  line-height: 32px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.grey100_1};
  margin: ${({ $first }) => ($first ? '0 0 25px' : '25px 0')};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  @media ${Media.smMax} {
    flex-direction: column;
    align-items: flex-start;
    > *:first-child:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;
export default SectionTitle;
